/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "@/core/router/router";
import Argon from "@/core/plugins/argon-kit";
import "@/core/plugins/treeselect";
import "@/core/plugins/vuemask";
import VueSimpleAlert from "vue-simple-alert";

import ApiService from "@/core/services/api.service";
ApiService.init();


// import vuetify from "@/core/plugins/vuetify";
import './registerServiceWorker'
import "@/core/plugins/bootstrap-vue";
import store from "@/core/store";
// import VueGtag from "vue-gtag";
import VueAnalytics from 'vue-analytics';
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false

Vue.component('bbt')

Vue.use(VueLazyload)


// Vue.use(VueGtag, {
//   config: { id: "G-B8809T2DF5" }
// });

import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.component(VueQrcode.name, VueQrcode);
Vue.use(VueAnalytics, {
  id: 'G-B8809T2DF5',
  disableScriptLoader: true
});

Vue.use(VueSimpleAlert);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
